import { React, useEffect, useState } from 'react';
import { apiUrl } from '../../config'
import { fetchData } from '../../utils/api';
import { intervalUpdatingData } from '../../utils/dynamic';
import DownloadReport from './DownloadReport';

function Dashboard({ type }) {
  const [dashboardInfo, setDashboardInfo] = useState([])

  const fetch = async () => {
    const token = localStorage.getItem('accessToken');
    const response = await fetchData(`${apiUrl}/api/sys/get-dashboard-info?type=${type}`, "GET", token)
    if (response.request.status)
      console.error("Ошибка загрузки данных:", response.request.message);
    else {
      setDashboardInfo(response.request.data);
    }
  };
  useEffect(() => {
    fetch();
    const interval = setInterval(() => {
      setTimeout(() => {
        fetch()
      }, 3000)
    }, intervalUpdatingData)
    return () => clearInterval(interval);

  }, []);

  return (
    <section className="system-dashboard">
      <div className="card">
        <h3>Общий доход</h3>
        <p>{dashboardInfo.total_sum} TMT</p>
        <h3>Количество</h3>
        <p>{dashboardInfo.active_count_bookings}</p>
      </div>
      <div className="card">
        <h3>Доход за бронирования</h3>
        <p>{dashboardInfo.total_sumBooking} TMT</p>
        <h3>Количество</h3>
        <p>{dashboardInfo.active_forbookings_count}</p>
      </div>
      <div className="card">
        <h3>Доход за проживания</h3>
        <p>{dashboardInfo.total_sum_settle} TMT</p>
        <h3>Количество</h3>
        <p>{dashboardInfo.active_forsettle_count}</p>
      </div>
      {type === 'main' &&
        <div className="card">
          <h3>Отчет</h3>
          <DownloadReport />
        </div>
      }
    </section>
  );
}

export default Dashboard;
